// extracted by mini-css-extract-plugin
export default {"textLayout":"voluntaryRegistration_textLayout__1m23m","fw500":"voluntaryRegistration_fw500__666yi"};